import { useAsync } from "react-use"
import { isOrganizationAlloy } from "data/apis/foundry/organizations"

export default function useIsAlloy() {
  const { value, loading } = useAsync(isOrganizationAlloy)
  return [value, loading]
}
